function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
export default function GradientOverlay(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: "1440",
        height: "848",
        viewBox: "0 0 1440 848",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none"
    }, props), /*#__PURE__*/ React.createElement("rect", {
        width: "1440",
        height: "848",
        fill: "url(#paint0_linear_56_3)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "1440",
        height: "848",
        fill: "#111E32",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "1440",
        height: "848",
        fill: "url(#paint1_linear_56_3)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_56_3",
        x1: "987",
        y1: "450.248",
        x2: "-375.908",
        y2: "230.757",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#09327D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#D35337",
        stopOpacity: "0.08"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_56_3",
        x1: "1327",
        y1: "14.1333",
        x2: "367.682",
        y2: "804.931",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#EB2B2B",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#27224A"
    }))));
}

//# sourceMappingURL=GradientOverlay.js.map